<clr-modal #modal [clrModalOpen]="modalOpen()" (clrModalOpenChange)="modalOpen.set($event)" [clrModalSize]="'xl'">
  <div class="modal-title">
    <h3>{{ 'Mengeneinheiten bearbeiten' | mrTranslate }}</h3>
  </div>
  <div class="modal-body grid" id="grid-container">
    <div class="clr-row nxm">
      <form clrForm #f="ngForm" (ngSubmit)="saveIfValid()" class="clr-col-12 clr-row nxm width100" [clrLabelSize]="4">
        <clr-input-container class="clr-col-md-4">
          <label>{{ 'Code' | mrTranslate }}</label>
          <input clrInput type="text" ngModel name="Code" required />
          <clr-control-error *clrIfError="'required'">
            {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
          </clr-control-error>
        </clr-input-container>
        <clr-input-container class="clr-col">
          <label>{{ 'Bezeichnung' | mrTranslate }}</label>
          <input clrInput type="text" ngModel name="Bezeichnung" />
        </clr-input-container>
        <button type="submit" class="btn btn-primary clr-col-auto" [title]="'Speichern' | mrTranslate">
          <cds-icon shape="floppy" />
        </button>
      </form>
    </div>
    @if (meh(); as table) {
      @if (table.columns) {
        <clr-datagrid
          #grid
          class="datagrid-compact h-100 w-100-p"
          [clrDgItemsIdentityFn]="row => row?.ID"
          [clrDgRowSelection]="true"
          [clrDgSelectionType]="'single'"
          [clrDgSelected]="[selectedRow()]"
          (clrDgSelectedChange)="selectedRow.set($event[0])">
          @for (column of table.columns; track column.id) {
            <clr-dg-column [clrDgField]="column.id">
              <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                {{ column.id | mrTranslate }}
              </ng-container>
            </clr-dg-column>
          }
          <clr-dg-row *clrDgItems="let row of table.rows" [clrDgItem]="row">
            @for (cell of table.columns; track cell.id) {
              <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
            }
          </clr-dg-row>
          <clr-dg-footer>{{ table.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
        <div class="btn-group btn-primary btn-icon">
          <button
            class="btn btn-icon btn-success"
            [title]="'Neu' | mrTranslate"
            (click)="grid.selection.clearSelection()">
            <cds-icon shape="file" />
          </button>
          <button
            class="btn btn-icon btn-danger"
            [title]="'Löschen' | mrTranslate"
            (click)="deleteRow()"
            [disabled]="!selectedRow()">
            <cds-icon shape="times" />
          </button>
        </div>
      } @else {
        <clr-spinner class="centred" />
      }
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" (click)="modal.close()">
      {{ 'Beenden' | mrTranslate }}
    </button>
  </div>
</clr-modal>
